import React from "react";
import { useTrail, animated } from "@react-spring/web";
import {
  AlertOctagon,
  AlertTriangle,
  AlertCircle,
  Sparkles,
  CheckCircle2,
  Shield,
} from "lucide-react";
import { StatTile } from "@/components/atoms/salesforce-release/StatTile";
import type { BucketCounts } from "@/services/salesforce-release";

interface Props {
  counts: BucketCounts | null | undefined;
  totalComponents?: number | null;
}

const FALLBACK: BucketCounts = { breaking: 0, deprecated: 0, review: 0, improvement: 0, ok: 0 };

export const ImpactMetrics: React.FC<Props> = ({ counts, totalComponents }) => {
  const c = counts ?? FALLBACK;

  const tiles = [
    { title: "Breaking", value: c.breaking, icon: AlertOctagon, iconColor: "text-red-500", valueColor: "text-red-500" },
    { title: "Deprecated", value: c.deprecated, icon: AlertTriangle, iconColor: "text-orange-500", valueColor: "text-orange-500" },
    { title: "Review", value: c.review, icon: AlertCircle, iconColor: "text-yellow-500", valueColor: "text-yellow-500" },
    { title: "Improvement", value: c.improvement, icon: Sparkles, iconColor: "text-emerald-500", valueColor: "text-emerald-500" },
    { title: "OK", value: c.ok, icon: CheckCircle2, iconColor: "text-muted-foreground", valueColor: "" },
    { title: "Components Affected", value: totalComponents ?? 0, icon: Shield, iconColor: "text-primary", valueColor: "text-primary" },
  ];

  const trail = useTrail(tiles.length, {
    from: { opacity: 0, transform: "translateY(6px)" },
    to: { opacity: 1, transform: "translateY(0px)" },
    config: { tension: 340, friction: 28 },
  });

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
      {trail.map((style, i) => {
        const t = tiles[i];
        return (
          <animated.div key={t.title} style={style}>
            <StatTile
              title={t.title}
              value={t.value}
              icon={t.icon}
              iconColor={t.iconColor}
              valueColor={t.valueColor}
            />
          </animated.div>
        );
      })}
    </div>
  );
};

export default ImpactMetrics;
